const state = {
	status: '',
	token: localStorage.getItem('token') || '',
	user: '',
	role: localStorage.getItem('role') || ''
}

const getters = {
	isLoggedIn: state => !!state.token,
	authStatus: state => state.status,
	role: state => state.role
}

const mutations = {
	auth_request(state) {
		state.status = 'loading'
	},
	auth_success(state, userData) {
		state.status = 'success'
		state.token = userData.token
		state.user = userData.user
		state.role = userData.role
	},
	auth_error(state) {
		state.status = 'error'
	},
	logout(state) {
		state.status = '',
			state.token = ''
		state.role = ''
	}
}

const actions = {
	login({commit}, user) {
		return new Promise((resolve, reject) => {
			commit('auth_request')
			this.$http.post('rest/user/login', user)
				.then(resp => {
					const userData = {
						token: resp.data.token,
						user: resp.data.user,
						role: resp.data.role
					}

					localStorage.setItem('token', userData.token)
					localStorage.setItem('role', userData.role)

					commit('auth_success', userData)
					resolve(resp)
				})
				.catch(err => {
					commit('auth_error')
					localStorage.removeItem('token')
					localStorage.removeItem('role')
					reject(err)
				})
		})
	},
	logout({commit}) {
		return new Promise((resolve) => {
			commit('logout')

			localStorage.removeItem('token')
			localStorage.removeItem('role')

			resolve(true)
		})
	}
}

export default {
	namespaced: true,
	state,
	getters,
	mutations,
	actions
}